import { FormArray, FormGroup } from '@angular/forms';

import { QuestionType } from '../../core';
import { EvalFormValue } from '../model/eval-form-value.model';

import { maxScoreForQuestion } from './max-score-for-question.function';

export function rollupScore(
    form: FormGroup,
    value: EvalFormValue,
): EvalFormValue {
    const nextValue: EvalFormValue = JSON.parse(JSON.stringify(value));
    let fScore = 0;
    let fMScoreDiff = 0;

    (form?.controls?.groups as FormArray).controls.forEach((g, gi) => {
        const gv = nextValue.groups[gi];
        let gScore = 0;
        let gMScoreDiff = 0;

        ((g as FormGroup)?.controls?.sections as FormArray).controls.forEach(
            (s, si) => {
                const sv = nextValue.groups[gi].sections[si];
                let sScore = 0;
                let sMScoreDiff = 0;
                let sEveryScoreIsNull = true;

                (
                    (s as FormGroup)?.controls?.questions as FormArray
                ).controls.forEach((q, qi) => {
                    const qv = nextValue.groups[gi].sections[si].questions[qi];
                    const maxScore = maxScoreForQuestion(qv);
                    const hasScoring = maxScore != null;
                    let qScore = 0;
                    let answered = false;

                    switch (qv.type) {
                        case QuestionType.RadioButton:
                            // eslint-disable-next-line no-case-declarations
                            const o = qv.options.find(
                                (e) => e.optionId === qv.optionId,
                            );
                            qScore = o?.score;
                            answered = qv.optionId != null;
                            break;
                        case QuestionType.CheckBox:
                            qScore = qv.options?.[0]?.score;
                            answered = qv.boolValue != null;
                            break;
                        case QuestionType.TextBox:
                            qScore = qv.options?.[0]?.score;
                            answered = qv.textValue != null;
                            break;
                    }

                    sScore += qScore != null ? qScore : 0;
                    sMScoreDiff +=
                        hasScoring && answered && qScore == null ? maxScore : 0;
                    if (qv.type !== QuestionType.TextBox) {
                        sEveryScoreIsNull =
                            answered && qScore == null && sEveryScoreIsNull;
                    }
                    qv.score = qScore;
                    // q.patchValue({...qv}, {emitEvent: false});
                });

                if (sEveryScoreIsNull) {
                    // sScore = 0;
                    // sMScoreDiff = sv.maxScore;
                }

                gScore += sScore;
                gMScoreDiff += sMScoreDiff;
                sv.score = sScore;
                sv.diffMaxScore = Math.max(0, sv.maxScore - sMScoreDiff);
                // sv.percentage = scorePercentage(sScore, sv.maxScore);
                // s.patchValue({...sv}, {emitEvent: false});
            },
        );

        fScore += gScore;
        fMScoreDiff += gMScoreDiff;
        gv.score = gScore;
        gv.diffMaxScore = Math.max(gv.maxScore - gMScoreDiff);
        // gv.percentage = scorePercentage(gScore, gv.maxScore);
        // g.patchValue({...gv}, {emitEvent: false});
    });

    nextValue.score = fScore;
    nextValue.diffMaxScore = Math.max(0, nextValue.maxScore - fMScoreDiff);
    // value.percentage = scorePercentage(fScore, value.maxScore);
    // this._evalFormGroup.patchValue({...value}, {emitEvent: false});

    return nextValue;
}
